import DeleteIcon from "@mui/icons-material/Delete";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { useState } from "react";

import { RDialog } from "@/shared/components/forms";

import deleteRiskApi from "../api/deleteRiskService";

type DeleteRiskButtonProps = {
  rowSelection: string[];
  refetchRisk: () => void;
};

export default function DeleteRiskButton({
  rowSelection,
  refetchRisk,
}: DeleteRiskButtonProps) {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleDeleteRisk = async () => {
    try {
      await deleteRiskApi(rowSelection[0]);
      refetchRisk(); // refetches data
    } catch (error) {
      // @todo deal with error
    }
    handleClose();
  };

  return (
    <>
      <MenuItem key="delete" onClick={handleOpen}>
        <DeleteIcon fontSize="small" />
      </MenuItem>

      <RDialog
        isOpen={isModalOpen}
        title="Delete Selected Risk"
        cancelButtonCallback={handleClose}
        confirmButtonCallback={handleDeleteRisk}
        confirmButtonText="Delete"
        confirmButtonType="error"
        size="small">
        <Typography variant="h5" sx={{ textAlign: "center" }}>
          Are you sure you want to delete the selected risk?
        </Typography>
      </RDialog>
    </>
  );
}
